// Frontend configuration. Create React App only inlines environment
// variables prefixed with REACT_APP_ into the client bundle at build time
// — everything else in the project's .env stays backend-only. See
// craco.config.js for how these get forwarded from the shared root .env,
// and /roles.js for how config.user.role drives tab visibility.
const config = {
  user: {
    name: process.env.REACT_APP_USER_NAME || '',
    email: process.env.REACT_APP_USER_EMAIL || '',
    role: process.env.REACT_APP_USER_ROLE || '',
  },
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api',
  refreshIntervalMinutes: Number(process.env.REACT_APP_REFRESH_INTERVAL_MINUTES) || 15,
  timezone: process.env.REACT_APP_TIMEZONE || 'America/New_York',
};

export default config;
